import { render, staticRenderFns } from "./SearchGDPR.vue?vue&type=template&id=5d588d4c&"
import script from "./SearchGDPR.vue?vue&type=script&lang=js&"
export * from "./SearchGDPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports